import Grid from "@mui/material/Grid";
import useStyles from "./styles";

export default function EspacoConteudoLateralDireito(props) {
  const classes = useStyles();

  return (
    <Grid
      alignItems="stretch"
      item
      xs={12}
      sm={8}
      md={8}
      // direction="row"
      style={props?.style}

      className={classes.box}
    >
      {props.children}
    </Grid>
  );
}
